import React, { createContext, useState, useEffect, useMemo } from 'react';
import UserService from '../services/api/admin/users/user_client';
import { getUserId } from '../utils/common_utils';

export const ComplianceContext = createContext();

export default function ComplianceProvider({ children }) {
  const [complianceStatus, setComplianceStatus] = useState(undefined);
  const [complianceUser , setComplianceUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch compliance status on provider mount
  useEffect(() => {
    const fetchComplianceStatus = async () => {
      try {
        const user  = JSON.parse(sessionStorage.getItem("user"));
        const userId = user?.id;
        const userRole = user?.role;

        if (userId && userRole) {
          const res = await UserService.getUserMe(userId);

          if(res?.data){
            setComplianceUser(res?.data)
          }

          if (res?.data?.[0]) {
            setComplianceStatus({
              color: res.data[0]?.color,
              message: res.data[0]?.message,
              status: res.data[0]?.status
            });
          }
        }
      } catch (err) {
        console.error('Failed to fetch compliance status:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchComplianceStatus();
  }, []);

  const clearComplianceStatus = () => {
    setComplianceStatus(undefined);
  };
  const contextValues = useMemo(()=>({ complianceStatus, isLoading, clearComplianceStatus , complianceUser  }), [complianceStatus, isLoading , complianceUser])

  return (
    <ComplianceContext.Provider value={contextValues}>
      {children}
    </ComplianceContext.Provider>
  );
}
